var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/input-moment/~/lodash/_Symbol.js
// module id = 542
// module chunks = 2